import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const riskAssessmentsStatusClassNames = {
  notApplicable: {
    indicator: 'tw-bg-grey-300',
    text: 'tw-text-grey-300',
  },
  outOfDate: {
    indicator: 'tw-bg-red-500',
    text: 'tw-text-red-500',
  },
  upToDate: {
    indicator: 'tw-bg-green-400',
    text: 'tw-text-green-400',
  },
};

export default function RiskAssessmentsStatusIndicator({ status }) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const statusClassNames = riskAssessmentsStatusClassNames[status];

  if (!statusClassNames) return null;

  return (
    <div className='tw-flex tw-min-w-0 tw-items-center'>
      <div
        className={classNames(
          'tw-inline-flex tw-h-2.5 tw-w-2.5 tw-flex-none tw-rounded-full',
          statusClassNames.indicator,
        )}
      />
      <div
        className={classNames(
          'tw-ml-1 tw-truncate tw-text-s tw-font-medium tw-tracking-wide',
          statusClassNames.text,
        )}
      >
        {i18nTShared(status)}
      </div>
    </div>
  );
}

RiskAssessmentsStatusIndicator.propTypes = {
  status: PropTypes.oneOf([
    ...Object.keys(riskAssessmentsStatusClassNames),
    'noStatus',
  ]),
};
